import React from 'react';
import { Button, Icon } from '@tcc/crate';
import styles from './styles.css';

interface Props {
  show: boolean;
  onDismiss: () => void;
  message: string;
  icon: React.ReactNode;
  dismissLabel: string;
  mainActionLabel?: string;
  onMainActionClick?: () => void;
}

export const MarketingBanner = ({
  show,
  onDismiss,
  message,
  icon,
  dismissLabel,
  mainActionLabel,
  onMainActionClick,
}: Props) => {
  if (!show) return null;

  return (
    <div className={styles.container} data-test-id="marketing-banner-container">
      <div className={styles.iconContainer}>
        {icon || <Icon glyph={Icon.set.COG} />}
      </div>
      <div className={styles.messageContainer}>
        <span>{message}</span>
      </div>
      <div className={styles.actionsContainer}>
        {mainActionLabel && typeof onMainActionClick === 'function' ? (
          <Button
            mode="marketing_secondary"
            onClick={onMainActionClick}
            className={styles.ctaButton}
          >
            {mainActionLabel}
          </Button>
        ) : null}
        <Button mode="primary" onClick={onDismiss} role="button">
          {dismissLabel}
        </Button>
      </div>
    </div>
  );
};
